import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';
import {NotificationService} from "../service/notification.service";
import {LanguageService} from "../service/language.service";
import {Lang} from "../model/lang.model";
import {keys} from "../shared/constants";
import {Locale} from "sdv-common";
import {CookieService} from "ngx-cookie-service";
import {UserService} from "../service/user.service";

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit {

  constructor(public apiService: ApiService,
              public userService: UserService,
              public cookieService: CookieService,
              public languageService: LanguageService,
              public notificationService: NotificationService) {
  }

  ngOnInit() {
  }

  switchLang(language: Lang) {
    let settings = JSON.parse(this.cookieService.get(keys.settings) || '{}');
    if (language.id === Locale.RUSSIAN.id) {
      settings.lang = Locale.RUSSIAN.name;
    } else if (language.id === Locale.UKRAINE.id) {
      settings.lang = Locale.UKRAINE.name;
    } else {
      settings.lang = Locale.ENGLISH.name;
    }
    this.cookieService.set(keys.settings, JSON.stringify(settings));
  }
}
